/**
 * Single source of truth for app-identity strings shown in the UI.
 *
 * APP_VERSION is injected at build time from package.json (see vite.config.mjs
 * `define.__APP_VERSION__`). Previously the version was hardcoded in two places
 * that disagreed — the sidebar said v0.1.0 while Configuration said 1.0.0 — which
 * made the app look unversioned/untrustworthy. Read it from here everywhere.
 *
 * The typeof guard keeps this working under Vitest, where the define isn't
 * applied, without throwing a ReferenceError.
 */
/* global __APP_VERSION__ */
export const APP_VERSION =
  typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0-dev';

// Version of the in-app feature/plugin system (distinct from the app release).
// Kept here so it, too, has one home rather than being retyped inline.
export const FEATURE_SYSTEM_VERSION = '1.2';

// Where a fresh operator gets the desktop agent. Install it on the computer you
// want to watch, then pair it with a code from this site. Point this at a real
// release channel when one exists; the onboarding guide degrades gracefully
// (hides the button) if it's left blank.
export const DESKTOP_APP_DOWNLOAD_URL = 'https://inquisitor.app/download';

// The public site a desktop user is told to open to get a pairing code. Shown
// in the desktop app's first-run pairing guide.
export const WEB_APP_URL = 'https://inquisitor.app';
